var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("header-actions")],2)]),_c('main',[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }